import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class AverageageofsugarcaneListService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	searchAverage(token, nome, status, orderby, sort, page) {
		

		
		
		
		
		
		

		var statusFilter = "";
		if (status != "") statusFilter = "and Ativo eq " + status;

		page = page * globalConst.paginationSkip;

		return this.http
		.get(this.apiUrl + "averageageofsugarcane/v1/getaverageageofsugarcane?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=startswith(tolower(Nome),'" + nome.toLowerCase() + "') " + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/averageageofsugarcane/service/averageageofsugarcane-list/averageageofsugarcane-list.service.ts